//
//
//
//
//
//
//
//
//
//
//
//
//

import FlowStep from "@/0/components/comForm/comFlowStep";
import FormDetail from "@/0/components/comForm/comFormDetail";
export default {
  components: {
    "flow-step": FlowStep,
    "form-detail": FormDetail
  },
  data() {
    return {
      isFormInit: false,
      stepConfig: {
        curStep: 1,
        list: ["填报活动销量", "提交成功,等待审核", "核销通过"],
        color: "rgb(81,170,56)"
      },

      dataItem: null,
      formConfig: {},
      formViewDataList: []
    };
  },
  async created() {
    await this.initForm();
  },

  methods: {
    
    async initForm() {
      this.isFormInit = false;

      var openId = this.$route.query.openId;
      if (!openId) {
        this.$msg.alert("无效操作.");
        return;
      }

      this.$msg.showLoading("正在获取详细信息...");
      var url = "/mSmsApi/ShopActivitySalesCheckOrder/GetDetailForm";
      var postData = {
        OpenId: openId
      };
      let { data: result } = await this.$http({
        method: "post",
        url: url,
        data: postData
      });
      this.$msg.hideLoading();
      if (result.state == 1) {
        this.dataItem = result.data.DataItem;
        this.isFormInit = true;
        this.$msg.succ("核验通过");
        this.formViewDataList = result.data.GroupViewList;
        return;
      }
      this.$msg.alert(result.msg);
      console.log(result);
    },

    onBackClick() {
      window.history.back(-1);
    }
  }
};
